import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box,
  Radio,
  Button
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, formatDate, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { SelectDoctorTable } from '../../HMS/masters/others/SelectDoctorTable';
import { INDENT_TYPE_DROPDOWN } from '../../../../../constants/dropdown';

const CANCEL_IPD_HEADER = [
  { header: 'Indent No.', accessor: 'indent_no' },
  { header: 'Cancel No.', accessor: 'cancel_no' },
  { header: 'UHID', accessor: 'uhid' },
  { header: 'IPD No.', accessor: 'ipd_no' },
  { header: 'Cancel Date', accessor: (row) => formatDate(row?.createdAt) },
  {
    header: 'Patient Name',
    accessor: (row) => `${row?.patient.name_suffix} ${row?.patient.first_name} ${row.patient.last_name}`
  }
];

const CANCEL_IPD_TABLE_COLUMNS = [
  {
    header: 'Indent No.',
    accessor: 'indent_no'
  },
  {
    header: 'ADM No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
    accessor: (row) => `${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name}`
  }
];

const CANCEL_IPD_TABLE_RETURN_COLUMNS = [
  {
    header: 'Indent No.',
    accessor: 'indent_no'
  },
  {
    header: 'ADM No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name',
    accessor: (row) => `${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name}`
  }
];

const CANCEL_IPD_INDENT_TABLE_HEADER = [
  { header: 'Ident Medicine Name', accessor: (row) => row?.medicineDetails?.name?.main?.name || '-' },
  { header: 'Ident Qty.', accessor: (row) => row?.quantity || '-' }
];

const initialPatientDataObj = {
  data: [],
  loading: false
};

const initialIndentCancelDataObj = {
  data: [],
  loading: false
};

const initialMedcineReturnDataObj = {
  data: [],
  loading: false
};

export const CancelIPDIndent = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [indentCancelObj, setIndentCancelObj] = useState(initialIndentCancelDataObj);
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
  const [indentMedicineReturnDataObj, setIndentMedicineReturnDataObj] = useState(initialMedcineReturnDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [input, setInput] = useState('');
  const [warehouse, setWareHosue] = useState([]);
  const [taxTableData, setTaxTableData] = useState([{ gst: 0, bill_amount: 0, cgst: 0, sgst: 0 }]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [indentDetail, setIndentDetail] = useState([]);

  useEffect(() => {
    const taxMap = {};
    selectedRows.forEach((item) => {
      const { gst, quantity, rate, mrp } = item;
      const total = quantity * mrp;
      const taxableAmount = total;
      const cgst = (taxableAmount * gst) / 200;
      const sgst = (taxableAmount * gst) / 200;
      if (taxMap[gst]) {
        taxMap[gst].taxable_amount += taxableAmount;
        taxMap[gst].cgst += cgst;
        taxMap[gst].sgst += sgst;
      } else {    
        taxMap[gst] = {
          gst,
          taxable_amount: taxableAmount,
          cgst,
          sgst
        };
      }
    });
    const newTaxTableData = Object.values(taxMap).map((item) => ({
      gst: item.gst,
      taxable_amount: Number(item.taxable_amount.toFixed(2) - (Number(item.taxable_amount) * Number(item.gst)) / 100),
      cgst: Number(item.cgst.toFixed(2)),
      sgst: Number(item.sgst.toFixed(2))
    }));
    setTaxTableData(newTaxTableData);
  }, [selectedRows]);

  const user = JSON.parse(localStorage.getItem('user'));
  const { getValues } = useForm();
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      cancel_date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      indent_type: 'MEDICINE ISSUE'
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const formSubmit = async (formValues) => {
    setLoading(true);
    const updatedSelectedRows = selectedRows.map((data) => ({
      ...data,
      medicine: data.medicine,
      quantity: data.quantity
    }));
    const payload = {
      ...formValues,
      items: updatedSelectedRows
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/' : '/ipd-indent-cancel-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Cancel Ipd Indent`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Cancel Ipd Indent`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setIndentCancelObj({ loading: true });
    const response = await request('/ipd-indent-cancel-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setIndentCancelObj({ loading: false, data: filteredData });
    } else {
      toast('Failed to load Retail Sale list', { variant: 'error' });
      setIndentCancelObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }
    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getLocationDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    setWareHosue(data);
  }, []);

  useEffect(() => {
    getLocationDropdown();
    getDoctorDropdown();
  }, [getLocationDropdown, getDoctorDropdown]);

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }
    return age;
  };

  const handleRowClick = (row) => {
    setValue('doctor', row?.patientIpdInfo?.consultant_detail?.doctor);
    setValue('patient_name', `${row?.patient?.name_suffix}${row?.patient?.first_name}${row?.patient?.last_name}`);
    setValue('gender', row?.patient?.gender);
    const formattedRegDate = row?.date ? new Date(row.date).toISOString().split('T')[0] : '';
    setValue('indent_date', formattedRegDate);
    setValue('indent_no', row?.indent_no);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('sponsor', row?.patientInfo?.sponsorInfo?.name);
    setValue('uhid', row?.uhid);
    setValue('ipd_no', row?.ipd_no);
    setValue('indent_by', user.name);
    setValue('room', row?.patientIpdInfo?.consultant_detail?.room);
    setValue('ward', row?.wardInfo?.name);
    setIndentDetail(row?.items);
    setValue('location', row?.location_to);
  };

  const fetchIpdPatient = useCallback(async () => {
    setIndoorRegisterationDataObj({ loading: true });
    try {
      const response = await request('/indent-medicine-issue-lists', { method: 'GET' });
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.authorize === true && item.indent_type === 'M' && item.patient_type === 'ipd_indent'
        );
        setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching indent list data', { variant: 'error' });
        setIndoorRegisterationDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching IPD patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  }, []);

  const fetchMedicineReturnPatient = useCallback(async () => {
    setIndentMedicineReturnDataObj({ loading: true });
    try {
      const response = await request('/indent-medicine-returns-lists', { method: 'GET' });
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.authorize === true && item.indent_type === 'MR' && item.patient_type === 'ipd_indent'
        );
        setIndentMedicineReturnDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching indent list data', { variant: 'error' });
        setIndentMedicineReturnDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching IPD patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setIndentMedicineReturnDataObj({ loading: false });
    }
  }, []);

  useEffect(() => {
    fetchIpdPatient();
    fetchMedicineReturnPatient();
  }, [fetchIpdPatient, fetchMedicineReturnPatient]);

  useEffect(() => {
    if (selectedRecord) {
      setIndentDetail(selectedRecord?.items);
      setValue('issue_no', selectedRecord?.issue_no);
      setValue('total_amt', selectedRecord?.total_amt);
      setValue('recpt_1', selectedRecord?.recpt_1);
      setValue('recpt_2', selectedRecord?.recpt_2);
      setValue('indent_by', selectedRecord?.indent_by);
      setValue('uhid', selectedRecord?.uhid);
      setValue('ipd_no', selectedRecord?.ipd_no);
      setValue('cancel_no', selectedRecord.cancel_no);
      setValue(
        'patient_name',
        `${selectedRecord?.patient?.name_suffix} ${selectedRecord?.patient?.first_name} ${selectedRecord?.patient?.last_name}`
      );
      setValue('gender', selectedRecord?.patient?.gender);
      setValue('age', calculateAge(selectedRecord?.patient?.dob));
      setValue('doctor', selectedRecord?.patientIpdInfo?.consultant_detail?.doctor);
      setValue('sponsor', selectedRecord?.patientInfo?.sponsorInfo?.name);
      setValue('pay_mode', selectedRecord?.pay_mode);
      setValue('remarks', selectedRecord?.remarks);
      setValue('ref_no', selectedRecord?.ref_no);
      setValue('indent_no', selectedRecord?.indent_no);
      setValue('ward', selectedRecord?.wardInfo?.name);
      setValue('location', selectedRecord?.indentRequisitions.location_to);
      const formattedDate = selectedRecord?.indent_date
        ? new Date(selectedRecord.indent_date).toISOString().split('T')[0]
        : '';
      setValue('indent_date', formattedDate);
      setValue('indent_by', selectedRecord?.indentRequisitions.createdBy);
    } else {
      reset();
    }
  }, [selectedRecord]);

  const isRowSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedRows)) {
      setSelectedRows([]);
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const searchCancelIndent = async () => {
    setIndentCancelObj({ loading: true });
    try {
      const response = await request('/ipd-indent-cancel-list', {
        method: 'GET',
        query: { name: input.toLowerCase() }
      });
      if (response.success) {
        setIndentCancelObj({ loading: false, data: response.data });
      } else {
        toast('Failed to load Ipd Indent Cancel', { variant: 'error' });
        setIndentCancelObj({ loading: false });
      }
    } catch (error) {
      toast('An unexpected error occurred', { variant: 'error' });
      setIndentCancelObj({ loading: false });
    }
  };

  useEffect(() => {
    searchCancelIndent();
  }, [input]);

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1.5,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1, borderBottom: '0px solid', borderColor: 'grey.300' }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Cancel IPD Indent
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    setIndentDetail([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                mt: 1.5,
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Indent Type</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.8,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="indent_type"
                      placeholder="Indent Type"
                      menus={INDENT_TYPE_DROPDOWN}
                    />
                  </Stack>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '40rem', marginTop: '1%' }}>
                    {watch('indent_type') === 'MEDICINE ISSUE' && (
                      <Table
                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '45rem' }}
                        data={(currentAction === 'new' && indoorRegisterationDataObj.data) || []}
                        columns={CANCEL_IPD_TABLE_COLUMNS}
                        size="small"
                        onRowClick={(row) => {
                          handleRowClick(row);
                        }}
                      />
                    )}
                    {watch('indent_type') === 'MEDICINE RETURN' && (
                      <Table
                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '45rem' }}
                        data={(currentAction === 'new' && indentMedicineReturnDataObj.data) || []}
                        columns={CANCEL_IPD_TABLE_RETURN_COLUMNS}
                        size="small"
                        onRowClick={(row) => {
                          handleRowClick(row);
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={8.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Cancel No.</Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="cancel_no"
                          placeholder="cancel no."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Indent No.</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="indent_no" placeholder="Indent No" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}> UHID/Adm No. </Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="uhid" placeholder="Uhid" />
                        <TextField disabled sx={{ flex: 0.4 }} name="ipd_no" placeholder="IPD No" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Ward</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="ward" placeholder="Ward" />
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Cancel Date</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="cancel_date" type="date" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Indent Date</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="indent_date" type="date" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="patient_name" placeholder="Patient Name" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                        <SelectTag
                          menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="doctor"
                          placeholder="Doctor Name"
                        />
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                        <SelectTag
                          disabled
                          formControlSX={{ flex: 0.8 }}
                          name="location"
                          placeholder="Location"
                          menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Indent By</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="indent_by" placeholder="Indent By" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Gender/Age</Typography>
                        <TextField disabled sx={{ flex: 0.4 }} name="gender" placeholder="Gender" />
                        <TextField disabled sx={{ flex: 0.4 }} name="age" placeholder="Age" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="sponsor" placeholder="Sponsor" />
                      </Stack>
                    </Grid>
                  </Stack>
                  <SelectDoctorTable
                    containerSX={{ p: 0.3, flex: 5, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={indentDetail.map((data) => ({ ...data, _id: data.medicine })) || []}
                    columns={CANCEL_IPD_INDENT_TABLE_HEADER}
                    size="medium"
                    showInputField={true}
                    showOk={true}
                    isSelected={isRowSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={selectedRecord ? '' : 'new'}
                    selectedRows={selectedRows}
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Cancel IPD Indent Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search by Cancel No."
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={CANCEL_IPD_HEADER}
          data={indentCancelObj.data || []}
          loading={indentCancelObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
